module.exports = __webpack_public_path__ + "img/leiderschap.2fb9440b.jpg";